import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import CreateLeadPage from "./pages/CreateLeadPage";
import DashboardPage from "./pages/DashboardPage";
import SignInForm from "./components/auth/SignInForm";
import SignUpForm from "./components/auth/SignUpForm";

import ElectricityContracts from "./pages/ElectricityContacts";
import Agents from "./pages/Agents";
import AdvancedSearch from "./pages/AdvanceSearch";
import Reports from "./pages/Reports";
import ProtectedRoute from "./components/ProtectedRoute";
import ChangePassword from "./pages/ChangePassword";
import Quality from "./pages/Quality";
import Rejects from "./pages/Rejects";
import Holds from "./pages/Hold";
import LeadListPage from "./pages/LeadListPage";
import LeadDetailsPage from "./pages/LeadDetailsPage";
import ValidatedLeads from "./pages/validate/Validate";
import ValidatedLowaq from "./pages/validate/ValidateLowaq";
import Validated00 from "./pages/validate/Validate00";
import EditLeadPage from "./pages/EditLeadPage";
import CallbackLeadsPage from "./pages/LeadDisposition/CallBackLeads";
import QualityLeadsPage from "./pages/LeadDisposition/QualityLeads";
import QualityLowAQPage from "./pages/LeadDisposition/QualityLowAq";
import QualityOOPage from "./pages/LeadDisposition/Quality00Leads";
import QualityLeadsDetails from "./pages/LeadDisposition/QualityLeadsDetails";
import QualityLowAQDetailsPage from "./pages/LeadDisposition/QualityLowAQDetailsPage";
import Quality00LeadsDetails from "./pages/LeadDisposition/Quality00LeadsDetails";
import CallbackLeadsDetails from "./pages/LeadDisposition/CallBackLeadsDetails";
import AdvancedSearchLeadDetails from "./pages/AdvanceSearchDetails";
import ValidateDetails from "./pages/validate/ValidateDetails";
import Validate00Details from "./pages/validate/Validate00Details";
import ValidateLowaqDetails from "./pages/validate/ValidateLowaqDetails";
import HoldLeadsDetails from "./pages/HoldDetails";
import RejectsDetails from "./pages/RejectsDetails";
import SoldLeadsPage from "./pages/Sold";
import SoldLeadsDetails from "./pages/SoldLeadsDetails";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 🔐 Auth Routes */}
        <Route path="/signin" element={<SignInForm />} />
        <Route path="/signup" element={<SignUpForm />} />

        {/* 🧩 Protected Layout Routes */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/leads/new" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="leads/new" element={<CreateLeadPage />} />

          <Route path="electricity-contracts" element={<ElectricityContracts />} />
          <Route path="agents" element={<Agents />} />
          <Route path="advance" element={<AdvancedSearch />} />
          <Route path="/leads/advanced-search/:id" element={<AdvancedSearchLeadDetails />} />
          <Route path="reports" element={<Reports />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/quality/:id" element={< QualityLeadsDetails />} />

          <Route
            path="/quality-low-aq-details/:id"
            element={<QualityLowAQDetailsPage />}
          />
          <Route
            path="/quality00-leads/:id"
            element={<Quality00LeadsDetails />}
          />
          <Route
            path="/callback-leads-details/:id"
            element={<CallbackLeadsDetails />}
          />
          <Route path="/rejects" element={<Rejects />} />
          <Route path="/hold" element={<Holds />} />
          <Route path="/hold-leads-details/:id" element={<HoldLeadsDetails/>} />
          <Route path="/reject-leads-details/:id" element={<RejectsDetails/>} />

          <Route path="/leadslist" element={<LeadListPage />} />
          <Route path="/leads/:id" element={<LeadDetailsPage />} />
          <Route path="/leads/edit/:id" element={<EditLeadPage />} />
          <Route
            path="/callback-leads"
            element={<CallbackLeadsPage />}
          />
          <Route
            path="/quality-leads"
            element={< QualityLeadsPage />}
          />
          <Route
            path="/qualitylowaq-leads"
            element={<  QualityLowAQPage />}
          />
          <Route
            path="/quality00-leads"
            element={<QualityOOPage />}
          />
          <Route
            path="/validate"
            element={<ValidatedLeads />}
          />
          <Route
            path="/validate-leads-details/:id"
            element={<ValidateDetails />}
          />
          <Route
            path="/validate-low-aq"
            element={<ValidatedLowaq />}
          />
          <Route
            path="/validate-low-aq-details/:id"
            element={<ValidateLowaqDetails />}
          />

          <Route
            path="/validate-00"
            element={< Validated00 />}
          />
            <Route
            path="/validate-00-details/:id"
            element={<Validate00Details />}
          />
 <Route path="/sold" element={<SoldLeadsPage />} />
   <Route
            path="/sold/:id"
            element={<SoldLeadsDetails />}
          />

        </Route>

        {/* ❌ Fallback */}
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
}